import React from 'react';

interface IRupeeIconWIthBackground {
  width?: number;
  height?: number;
  background?: string;
  rupeeIconColor?: string;
}

const RupeeIconWIthBackground: React.FC<IRupeeIconWIthBackground> = props => {
  const { width = 12, height = 16, background = '#3B64F4', rupeeIconColor = 'white' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="8" r="6" fill={background} />
      <path
        d="M7.89025 5.848H6.69025C6.90358 6.03467 7.03692 6.28533 7.09025 6.6H7.89025V7.152H7.11425C7.07158 7.57867 6.90625 7.92267 6.61825 8.184C6.33558 8.44 5.95425 8.58667 5.47425 8.624L7.13825 11H6.12225L4.58625 8.632H4.02625V7.976H5.09825C5.79692 7.976 6.19425 7.70133 6.29025 7.152H4.02625V6.6H6.27425C6.17292 6.09867 5.78092 5.848 5.09825 5.848H4.02625V5.304H7.89025V5.848Z"
        fill={rupeeIconColor}
      />
    </svg>
  );
};

export default RupeeIconWIthBackground;
